module.exports = __webpack_public_path__ + "static/media/SquashInaugural_20141115_5481.7c955a7b.jpg";